module.exports = __webpack_public_path__ + "assets/images/4718f1fe88099f4fecac2fe4fec3cab3.svg";